export const fog = {
  // 100: '#f4f4f4',
  100: '#fbfbff',
  95: '#F7F7FB',
  92: '#F2F4F9',
  90: '#EDF0F6',
  85: '#E4E7EE',
  80: '#CCCED9',
  70: '#B7B9C6',
  65: '#A5A7B4',
  50: '#8A8A98',
  45: '#807F8D',
  40: '#6F6E7B',
  35: '#585766',
  30: '#4D495E',
  25: '#3F3C4B',
  10: '#1D1E26',
} as const;

export type FogVariants = keyof typeof fog;
